/**
 * Parse a timestamp value from D1/SQLite for display.
 *
 * SQLite's `datetime('now')` returns a string like "2026-05-06 19:24:49"
 * with NO timezone marker. JavaScript's `new Date(s)` parses ambiguous
 * formats as local time, which silently shifts a UTC-clock value by the
 * browser's offset — e.g. a SAST user sees a 2-hour deficit.
 *
 * Detect the SQLite format and treat it as UTC. Other formats (ISO with Z,
 * ISO with offset like +02:00) are passed through unchanged.
 */
export function parseDbTimestamp(value: string | undefined | null): Date | null {
  if (!value) return null;
  // SQLite datetime('now'): YYYY-MM-DD HH:MM:SS  (UTC, no tz)
  if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/.test(value)) {
    return new Date(value.replace(' ', 'T') + 'Z');
  }
  // Anything else (ISO with Z or explicit tz offset) is parsed natively.
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}
